import { render, staticRenderFns } from "./Subbar.vue?vue&type=template&id=632b8d28&"
import script from "./Subbar.vue?vue&type=script&lang=js&"
export * from "./Subbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports